import Layout from '@layout/Index'

export const paymentRefund = [
  {
    path: '/payment-refund',
    component: Layout,
    children: [
      {
        path: '',
        redirect: 'table',
      },
      {
        path: 'table',
        component: () => import(/* webpackChunkName: "payment-refund-table" */ './pages/PaymentRefundTable.vue'),
        meta: {
          type: 'customer',
          title: '付款退款单列表',
        },
      },
      {
        path: 'finance/table',
        component: () => import(/* webpackChunkName: "payment-refund-finance-table" */ './pages/PaymentRefundTable.vue'),
        meta: {
          type: 'finance',
          title: '付款退款单列表',
        },
      },
      {
        path: 'finance/detail/:id',
        component: () => import(/* webpackChunkName: "payment-refund-detail" */ './pages/PaymentRefundDetail.vue'),
        meta: {
          type: 'finance',
          title: '付款退款单详情',
        },
      },
      {
        path: 'detail-redirect/:id',
        component: () => import(/* webpackChunkName: "payment-refund-detail-redirect" */ './pages/PaymentRefundDetailRedirect.vue'),
        meta: {
          title: '付款退款单跳转页',
        },
      },
      {
        path: 'customer/detail/:id',
        component: () => import(/* webpackChunkName: "payment-refund-detail" */ './pages/PaymentRefundDetail.vue'),
        meta: {
          type: 'customer',
          title: '付款退款单详情',
        },
      },
    ],
  },
]



// WEBPACK FOOTER //
// ./src/views/payment-refund/payment-refund.route.js